// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmhrrequestspg-inline-1 {
  padding: 0;
  overflow-x: auto;
}

.pmhrrequestspg-inline-2 {
  padding: 20px;
}

.pmhrrequestspg-inline-3 {
  text-align: center;
  padding: 22px;
  color: #94a3b8;
}

.pmhrrequestspg-inline-4 {
  font-family: monospace;
  font-size: 11px;
}

.pmhrrequestspg-inline-5 {
  font-weight: 600;
}

.pmhrrequestspg-inline-6 {
  margin-bottom: 8px;
  font-size: 12px;
}

.pmhrrequestspg-inline-7 {
  margin-bottom: 8px;
  display: flex;
  gap: 8px;
}

.pmhrrequestspg-inline-8 {
  margin-top: 8px;
}

.pmhrrequestspg-inline-9 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 10px;
}

.pmhrrequestspg-inline-10 {
  background: #d97706;
}

.pmhrrequestspg-inline-11 {
  background: #0ea5e9;
}

.pmhrrequestspg-inline-12 {
  margin-top: 14px;
}

.pmhrrequestspg-inline-13 {
  font-weight: 700;
  font-size: 12px;
  margin-bottom: 8px;
}

.pmhrrequestspg-inline-14 {
  color: #94a3b8;
  font-size: 12px;
}

.pmhrrequestspg-inline-15 {
  border-bottom: 1px solid #f1f5f9;
  padding: 6px 0;
}

.pmhrrequestspg-inline-16 {
  font-size: 11px;
  font-weight: 700;
}

.pmhrrequestspg-inline-17 {
  font-size: 11px;
  color: #64748b;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMHrRequestsPg.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".pmhrrequestspg-inline-1 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.pmhrrequestspg-inline-2 {\n  padding: 20px;\n}\n\n.pmhrrequestspg-inline-3 {\n  text-align: center;\n  padding: 22px;\n  color: #94a3b8;\n}\n\n.pmhrrequestspg-inline-4 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.pmhrrequestspg-inline-5 {\n  font-weight: 600;\n}\n\n.pmhrrequestspg-inline-6 {\n  margin-bottom: 8px;\n  font-size: 12px;\n}\n\n.pmhrrequestspg-inline-7 {\n  margin-bottom: 8px;\n  display: flex;\n  gap: 8px;\n}\n\n.pmhrrequestspg-inline-8 {\n  margin-top: 8px;\n}\n\n.pmhrrequestspg-inline-9 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.pmhrrequestspg-inline-10 {\n  background: #d97706;\n}\n\n.pmhrrequestspg-inline-11 {\n  background: #0ea5e9;\n}\n\n.pmhrrequestspg-inline-12 {\n  margin-top: 14px;\n}\n\n.pmhrrequestspg-inline-13 {\n  font-weight: 700;\n  font-size: 12px;\n  margin-bottom: 8px;\n}\n\n.pmhrrequestspg-inline-14 {\n  color: #94a3b8;\n  font-size: 12px;\n}\n\n.pmhrrequestspg-inline-15 {\n  border-bottom: 1px solid #f1f5f9;\n  padding: 6px 0;\n}\n\n.pmhrrequestspg-inline-16 {\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.pmhrrequestspg-inline-17 {\n  font-size: 11px;\n  color: #64748b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
